"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _epics = require("settings-content-modals/data/Owners/epics");

var _default = (0, _reduxObservable.combineEpics)(_epics.fetchOwners);

exports.default = _default;
module.exports = exports.default;